<template>
    <div class="echart-box">
        <v-chart :options="option" ref="my" autoresize/>
    </div>
</template>
<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/component/legend'
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/polar';
import 'echarts/lib/component/markPoint';
import 'echarts/lib/component/dataZoom';
import 'echarts/lib/component/title';
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/polar';
import 'zrender/lib/svg/svg'
export default {
    name:"char1",
    components:{
         'v-chart': ECharts
    },
    props:{
        datalist:{
            type:Object,
            default:()=>{
              return {
                  data1:[],
                  data2:[]
              }
            }
        },
        datelist:{
            type:Array,
            default:()=>{
              return []
            }
        }
    },
    data(){
        return {
            viewdata:{
                data1:[],
                 data2:[]
            },
            viewdate:[],
            option:{}
        }
    },
     watch:{
        datelist:{
            handler(){              
              this.dataInit();
              this.init()
            },
            deep:false
        }
    },
    methods:{
        dataInit(){              
            
            this.viewdata.data1= this.datalist.data1.slice(0,5); 
            this.viewdata.data2= this.datalist.data2.slice(0,5); 
            this.viewdate=this.datelist.slice(0,5);    
         
            this.doit()
        },
        //滚动动画
        doit(){    
            setTimeout(()=>{             
                this.runData()
            },3000)     
        },
        //滚动展示数据计算
        runData(){                 
            this.datalist.data1.push(this.datalist.data1.shift());
            this.datalist.data2.push(this.datalist.data2.shift());
            this.datelist.push(this.datelist.shift());      

        },       
        init(){            
            
              this.option={
                grid: {
                    top:'10%',
                    left: '5%',
                    right: '5%',
                    bottom:'10%',
                    containLabel: true
                },
                legend: {
                    bottom:'2%',
                    itemWidth:6,
                    itemHeight:6,
                    textStyle:{
                        color:"#fff"
                    },
                    icon:"rect",
                    data: ['微商城', '天猫']
                },
                tooltip:{
                    formatter: function(params,index) {    
                    　　var result = params[0].name+'</br>'
                    　　params.forEach(function (item) { 
                           
                                result += item.seriesName +":￥"+ item.data.value + "</br>";                                         
                           
                    　　})                   
                    　　return result                
                    },
                    textStyle:{
                        fontSize:this.chartFontSize
                    },
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",      
                        shadowStyle:{
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 1, color: 'rgba(246, 232, 87,0)' // 0% 处的颜色
                                }, {
                                    offset: 0, color: 'rgba(234, 205, 44,0.4)' // 100% 处的颜色
                                }],
                                global: false // 缺省为 false
                            }
                        }  
                    }
                },                
                xAxis: {
                    
                     splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#323645',
                            type: 'solid',
                            width:1,
                        },
                        minInterval:0
                    },
                    axisLabel: {             
                      color:'#fff'
                    },
                    type: 'category',                              
                    data:this.viewdate,
                },
                yAxis: {
                    axisLabel: {             
                      color:'#fff'
                    },
                     splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#323645',
                            type: 'dashed',
                            width:1,
                        },
                        minInterval:0
                    },
                    type: 'value'
                },
                series: [{
                    id:'a1',
                    name:"微商城",
                    data: this.viewdata.data1,
                    type: 'bar',
                    itemStyle:{
                        normal:{ 
                            color:"#2D99FF"
                        },                  
                    },
                    barWidth:this.barWidth        
                },
                {
                    id:'a2',
                    name:"天猫",
                    data: this.viewdata.data2,
                    type: 'bar',
                    itemStyle:{
                        normal:{ 
                            color:"#8943D3"
                        },                  
                    },
                    barWidth:this.barWidth   
                },
                
                ]
            }                  
            setTimeout(()=>{
                this.$nextTick(()=>{
                    this.$refs.my.dispatchAction({
                        type: 'showTip',         
                        seriesIndex: 0,
                        dataIndex: 2                     
                    })
                })
            },500)      
           
           
        }
    },
    mounted(){
        // /  this.init()
    }
}
</script>